module.exports = __webpack_public_path__ + "media/images/font/Gustavo-LightItalic-c1fd58023af7862b4b4ff080c3f830a1.eot";